import { Link } from 'react-router-dom';
import { PATHS } from '../../routes/paths';

const COLUMNS = [
{
  title: 'Browse',
  links: [
  { to: PATHS.vendorCategory('food-trucks'), label: 'Food trucks' },
  { to: PATHS.catering, label: 'Catering' },
  { to: PATHS.vendorCategory('bars'), label: 'Bars and carts' },
  { to: PATHS.rentals, label: 'Party rentals' },
  { to: PATHS.services, label: 'Entertainment' }]

},
{
  title: 'For vendors',
  links: [
  { to: PATHS.listYourService, label: 'List your service' },
  { to: PATHS.earnWithVgo, label: 'Earn with VGO' },
  { to: PATHS.vendorDashboard, label: 'Vendor dashboard' }]

},
{
  title: 'Account',
  links: [
  { to: PATHS.signupCustomer, label: 'Sign up' },
  { to: PATHS.customerDashboard, label: 'My bookings' },
  { to: PATHS.customerFavorites, label: 'Favorites' },
  { to: PATHS.messages, label: 'Messages' }]

},
{
  title: 'Support',
  links: [
  { to: PATHS.support, label: 'Help center' },
  { to: PATHS.terms, label: 'Terms of service' },
  { to: PATHS.privacy, label: 'Privacy policy' }]

}];

export default function Footer() {
  return (
    <footer className="border-t border-line bg-panel">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-[1.2fr_repeat(4,1fr)]">
        <div>
          <Link to={PATHS.home} aria-label="VGO home">
            <img src="/logo.svg" alt="VGO" className="h-8 w-auto" />
          </Link>
          <p className="mt-3 max-w-xs text-sm text-inksoft">
            Food, catering, rentals and services for your event, booked in one place.
          </p>
        </div>
        {COLUMNS.map((col) =>
        <nav key={col.title} aria-label={col.title}>
            <p className="text-xs font-bold uppercase tracking-wide text-inksoft">{col.title}</p>
            <ul className="mt-3 space-y-2">
              {col.links.map((link) =>
            <li key={link.label}>
                  <Link to={link.to} className="text-sm text-inksoft hover:text-ink">{link.label}</Link>
                </li>
            )}
            </ul>
          </nav>
        )}
      </div>
      <div className="border-t border-line">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-5 pb-[max(1.25rem,env(safe-area-inset-bottom))] text-[13px] text-inksoft sm:px-6">
          <span>© 2026 VGO. Everything for your event.</span>
          <div className="flex gap-5">
            <Link to={PATHS.support} className="hover:text-ink">Help</Link>
            <Link to={PATHS.terms} className="hover:text-ink">Terms</Link>
            <Link to={PATHS.privacy} className="hover:text-ink">Privacy</Link>
            <Link to={PATHS.vendors} className="hover:text-ink">Vendors</Link>
          </div>
        </div>
      </div>
    </footer>);

}